import 'bootstrap';
import 'slick-carousel';

(function ($) {
	// On Dom Ready
	$(function () {
		console.log('Dom loaded...');
	});
})(jQuery);
